module.exports = __webpack_public_path__ + "static/media/avatarVictoria.3221d936.jpg";